import merge from 'lodash/merge.js';

import Item from './Item.js';

export default merge(Item(), {
    state() {
        return {
            key: null,
            title: null,
            message: null,
            type: null,
        };
    },

    getters: {},

    actions: {},

    mutations: {},
});
